import Mention from "@tiptap/extension-mention";

export const AgentMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      email: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-email"),
        renderHTML: (attributes) => {
          return {
            "data-email": attributes.email,
          };
        },
      },
      class: {
        default: "mention",
        parseHTML: () => "mention",
        renderHTML: () => ({
          class: "mention",
        }),
      },
      "data-model": {
        default: "user",
        parseHTML: (element) => element.getAttribute("data-model"),
        renderHTML: (attributes) => ({
          "data-model": attributes["data-model"] || "user",
        }),
      },
      metadata: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-metadata"),
        renderHTML: (attributes) => {
          if (!attributes.metadata) return {};
          return {
            "data-metadata": attributes.metadata,
          };
        },
      },
    };
  },
});
